import { isBefore } from 'date-fns';
import { ScheduleEmployeeType } from 'store/scheduleEmployees/interfaces';
import { z } from 'zod';

const schema = z
  .object({
    schedule: z.string().min(1, { message: 'errors.field_required' }),
    dateFrom: z.date(),
    dateTo: z.date().nullable().optional(),
    type: z.nativeEnum(ScheduleEmployeeType, {
      errorMap: () => ({ message: 'errors.field_required' }),
    }),
  })
  .refine((data) => {
    if (data.type !== ScheduleEmployeeType.exception) {
      return true;
    }

    if (!data.dateTo) {
      return false;
    }

    return !isBefore(data.dateTo, data.dateFrom);
  });

export default schema;
